

export default `
    mutation ($input: ClientConnectionCreateInput){
        clientConnectionCreate(input: $input){
            clientList
            googleAnalytics{
                accountId
                propertyId
                viewId
                accountName
                propertyName
                viewName
                email
            }
            googleAds{
                mcc
                accountId
                accountName
                mccName
                email
            }
            googleSearchConsole {
                email
                propertyUrl
                propertyType
            }
            googleMyBusiness{
                email
                accountId
                locationId
            }
            facebookAds{
                accountId
                accountName
                businessId
                businessName
                email
            }
        }
    }
`;
